import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuComponent } from './core/containers/menu/menu.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { PartnerListResolver } from './features/partner/resolvers/partner-list.resolver';
import { TestComponentComponent } from './features/test-component/test-component.component';
import CanActivateLogged from './core/guards/logged';
import { environment } from 'src/environments/environment';
import { ProfileComponent } from './features/profile/profile.component';

const routes: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: 'articles',
    loadChildren: () => import('./features/articles/articles.module').then((m) => m.ArticlesModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'accounting',
    loadChildren: () => import('./features/accounting/accounting.module').then((m) => m.AccountingModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'promotion',
    loadChildren: () => import('./features/promotion/promotion.module').then((m) => m.PromotionModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'partner',
    loadChildren: () => import('./features/partner/partner.module').then((m) => m.PartnerModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'orders',
    loadChildren: () => import('./features/orders/orders.module').then((m) => m.OrdersModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'community',
    loadChildren: () => import('./features/community/community.module').then((m) => m.CommunityModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'logistics',
    loadChildren: () => import('./features/logistics/logistics.module').then((m) => m.LogisticsModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'terms-conditions',
    loadChildren: () => import('./features/terms-conditions/terms-conditions.module').then((m) => m.TermsConditionsModule),
  },
  {
    path: 'profile',
    component: ProfileComponent,
    data: { pageTitle: 'Profilo', breadcrumb: [{ key: 'Profilo', href: '/profile' }] },
    canActivate: [CanActivateLogged],
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'admin',
    component: TestComponentComponent,
    data: {
      pageTitle: 'Admin',
      breadcrumb: [
        { key: 'Admin', href: '/admin' },
        { key: 'Admin', href: '/admin' },
      ],
    },
    canActivate: [CanActivateLogged],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { pageTitle: 'Dashboard', breadcrumb: [{ key: 'Dashboard', href: '/dashboard' }] },
    resolve: { partnerList: PartnerListResolver },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canActivate: [CanActivateLogged],
  },
  {
    path: 'menu',
    component: MenuComponent,
    data: { pageTitle: 'Menu' },
    canActivate: [CanActivateLogged],
  },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];

const routes_small: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: 'articles',
    loadChildren: () => import('./features/articles/articles.module').then((m) => m.ArticlesModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'promotion',
    loadChildren: () => import('./features/promotion/promotion.module').then((m) => m.PromotionModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'community',
    loadChildren: () => import('./features/community/community.module').then((m) => m.CommunityModule),
    canActivate: [CanActivateLogged],
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'menu',
    component: MenuComponent,
    data: { pageTitle: 'Menu' },
    canActivate: [CanActivateLogged],
  },
  {
    path: 'terms-conditions',
    loadChildren: () => import('./features/terms-conditions/terms-conditions.module').then((m) => m.TermsConditionsModule),
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    data: { pageTitle: 'Dashboard', breadcrumb: [{ key: 'Dashboard', href: '/dashboard' }] },
    resolve: { partnerList: PartnerListResolver },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canActivate: [CanActivateLogged],
  },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },

];

@NgModule({
  imports: [
    RouterModule.forRoot(environment.menu ? routes : routes_small, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
